import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import Input from "../common/Input";

interface ReLoginCodeFormProps {
  busy: boolean;
  onSubmit: (code: string) => void;
}

/** Second re-login step: the 6-digit code, as in TwoFactorForm. */
const ReLoginCodeForm: React.FC<ReLoginCodeFormProps> = ({
  busy,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(code);
      }}
      className="mt-4 space-y-4"
    >
      <p className="text-sm text-gray-600">{t("auth.twoFactorSubtitle")}</p>
      <Input
        label={t("auth.authCode")}
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
        placeholder="123456"
        maxLength={6}
        required
        autoFocus
        className="text-center text-lg tracking-widest"
      />
      <Button
        type="submit"
        className="w-full"
        isLoading={busy}
        disabled={code.length !== 6}
      >
        {t("auth.verify")}
      </Button>
    </form>
  );
};

export default ReLoginCodeForm;
